import {Subject} from "rxjs";
import {ScorerEventTypes} from "./ScorerEventTypes";
import {INotesScore} from "../../../models/scorer/INotesScore";
import {IPerformanceScore} from "../../../models/scorer/IPerformanceScore";
import IVideoScore from "../../../models/scorer/IVideoScore";
import {logger} from "../../log/logger";

const notesEventSubject = new Subject<ScorerEventTypes>();

export function subscribeToScorerEvents(callback: (message: ScorerEventTypes) => void){
  const protectedCallback = (message: ScorerEventTypes) => {
    try{
      callback(message);
    }catch(e){
      logger.lessonScorer.error({message: `error encountered in observer of ScorerEventTypes `, error: e as Error});
    }
  };
  const subscription = notesEventSubject.subscribe(protectedCallback);
  return subscription.unsubscribe.bind(subscription);
}

function emitScorerEvent(message: ScorerEventTypes){
  notesEventSubject.next(message);
}

/**
 * These 3 events are not necessarily exclusionary.
 * Video scoring is done without notes or performance scoring.
 * However, notes and performance scoring are done together.
 * Note scoring happens first for non-video scoring, and then performance scoring is derived from the note scoring.
 */
export function emitNotesScoring_completed(notesScore: INotesScore){
  emitScorerEvent({type: "notesScoringCompleted", notesScore});
}

export function emitPerformanceScoring_completed(performanceScore: IPerformanceScore){
  emitScorerEvent({type: "performanceScoringCompleted", performanceScore});
}

export function emitVideoScoring_completed(videoScore: IVideoScore){
  emitScorerEvent({type: "videoScoringCompleted", videoScore});
}